{
  "id": "campaign-075",
  "name": "Quiet Links",
  "seed": "campaign:75",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "............",
    ".,...ooosss.",
    ",,...oFo..s.",
    ".,h..ooo.h..",
    "...www,,,...",
    "...www.,....",
    ".b........b.",
    "............",
    "..T......T..",
    ".~,x,.......",
    ".~~,,..x....",
    ".~h.,....h..",
    "............",
    "#...T..T....",
    "............",
    "....b..b....",
    "............",
    "S..........."
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 3,
      "y": 0
    },
    {
      "kind": "squirrel",
      "x": 9,
      "y": 2
    },
    {
      "kind": "squirrel",
      "x": 8,
      "y": 13
    },
    {
      "kind": "squirrel",
      "x": 1,
      "y": 4
    },
    {
      "kind": "squirrel",
      "x": 11,
      "y": 10
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 8,
      "y": 2
    },
    {
      "kind": "gas",
      "x": 1,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 6
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "generatorVersion": 3,
  "level": 75,
  "biome": "golf",
  "par": {
    "reel": 7885,
    "push": 6857,
    "selfPropelled": 6225,
    "tractor": 4898,
    "zeroTurn": 4171,
    "fairway": 3072
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 1,
      "tractor": 0,
      "zeroTurn": 21,
      "fairway": 8
    }
  }
}
